/**
 * FAQ Accordion for Pages with 3 Sections
 */
document.addEventListener('DOMContentLoaded', () => {
  const accordionButtons = document.querySelectorAll<HTMLButtonElement>('.accordion-trigger[data-accordion-target]');
  
  accordionButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const targetId = button.getAttribute('data-accordion-target');
      if (!targetId) return;
      
      const content = document.querySelector<HTMLElement>(targetId);
      if (!content) return;
      
      const icon = button.querySelector<SVGElement>('.accordion-icon');
      const isOpen = !content.classList.contains('hidden');
      
      if (isOpen) {
        // Close
        content.classList.add('hidden');
        icon?.classList.remove('rotate-180');
        button.setAttribute('aria-expanded', 'false');
      } else {
        // Open
        content.classList.remove('hidden');
        icon?.classList.add('rotate-180');
        button.setAttribute('aria-expanded', 'true');
      }
    });
  });
});



